import React from "react";
import { useNavigate } from "react-router-dom";
import { Onboarding } from "@/components/Onboarding";
import { OnboardingPageDesktop } from "./OnboardingPage.Desktop";
import { useIsDesktop } from "@/hooks/useMediaQuery";

export const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const handleComplete = () => {
    localStorage.setItem(
      `onboarding-completed-${import.meta.env.VITE_APP_VERSION}`,
      "true"
    );

    // Dispatch custom event to notify App of onboarding completion
    window.dispatchEvent(new CustomEvent("onboarding-completed"));

    // Navigate directly to referral-entry
    navigate("/referral-entry");
  };

  if (isDesktop) {
    return <OnboardingPageDesktop />;
  }

  return <Onboarding onComplete={handleComplete} />;
};
